// @ts-expect-error not typed yet

import { EMAIL_CREATION_TYPES, EMAIL_CREATION_TYPES_TO_EMAIL_TYPE, EMAIL_TEMPLATE_MODE_MODAL_TYPES, EMAIL_TYPE_ILLUSTRATIONS } from 'EmailData/constants/emailCreation';
import EMAIL_TYPE from 'EmailData/enums/EmailType';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import { Flex } from 'foundations-components/components/Flex';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { useCallback, useMemo } from 'react';
import SelectableButtonWithDescription from './SelectableButtonWithDescription';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function EmailTypeSelectableButtons({
  availableEmailTypes,
  creationType,
  selectedEmailType,
  shouldRenderEmailTypeSelectOption,
  onSelectType,
  imageHeight,
  email
}) {
  const types = Object.keys(EMAIL_CREATION_TYPES).filter(type => {
    if (creationType === EMAIL_TEMPLATE_MODE_MODAL_TYPES.CLONE) {
      return EMAIL_CREATION_TYPES_TO_EMAIL_TYPE()[type].canCloneTo !== false;
    }
    return true;
  });
  const canChangeEmailType = useMemo(() => !email || email.isBatch() || email.isAutomated(), [email]);
  const tooltip = useMemo(() => {
    if (!canChangeEmailType) {
      if (email.isABLike()) {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "EmailComponents.modals.creation.section.typeTooltipForAb"
        });
      }
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "EmailComponents.modals.creation.section.typeTooltip"
      });
    }
    return null;
  }, [canChangeEmailType, email]);
  const renderLabel = useCallback(type => {
    let langKey = type;
    if (EMAIL_CREATION_TYPES.BLOG_RSS === type && availableEmailTypes.indexOf(EMAIL_TYPE.RSS_EMAIL) < 0 && availableEmailTypes.indexOf(EMAIL_TYPE.BLOG_EMAIL) > -1) {
      langKey = 'BLOG';
    }
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      "data-test-id": `${langKey}-label`,
      message: `EmailComponents.modals.creation.chooseEmailType.label.${langKey}`
    });
  }, [availableEmailTypes]);
  const renderDescription = useCallback(type => {
    let langKey = type;
    if (EMAIL_CREATION_TYPES.BLOG_RSS === type && availableEmailTypes.indexOf(EMAIL_TYPE.RSS_EMAIL) < 0 && availableEmailTypes.indexOf(EMAIL_TYPE.BLOG_EMAIL) > -1) {
      langKey = 'BLOG';
    }
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      "data-test-id": `${langKey}-description`,
      message: `EmailComponents.modals.creation.chooseEmailType.description.${creationType}.${langKey}`
    });
  }, [availableEmailTypes, creationType]);
  const onSelectEmailType = useCallback(type => {
    return () => onSelectType(type);
  }, [onSelectType]);
  const getIsTypeIsUnavailable = useCallback(type => {
    return !!EMAIL_CREATION_TYPES_TO_EMAIL_TYPE()[type
    // @ts-expect-error none of those signatures are compatible with each other
    ].hasAll.find(emailType => availableEmailTypes.indexOf(emailType) < 0);
  }, [availableEmailTypes]);
  const buttons = useMemo(() => types.map(type => /*#__PURE__*/_jsx(SelectableButtonWithDescription, {
    "data-test-id": `selectable-button-${type}`,
    illustrationName: EMAIL_TYPE_ILLUSTRATIONS[EMAIL_CREATION_TYPES[type]],
    buttonLabel: renderLabel(EMAIL_CREATION_TYPES[type]),
    description: renderDescription(EMAIL_CREATION_TYPES[type]),
    onClick: onSelectEmailType(EMAIL_CREATION_TYPES[type]),
    isLocked: getIsTypeIsUnavailable(type),
    upgradeKey: EMAIL_CREATION_TYPES_TO_EMAIL_TYPE()[type].upgradeKey,
    isSelected: selectedEmailType === type,
    imageHeight: imageHeight
  }, EMAIL_CREATION_TYPES[type])), [getIsTypeIsUnavailable, imageHeight, onSelectEmailType, renderDescription, renderLabel, selectedEmailType, types]);
  const body = useMemo(() => {
    if (!canChangeEmailType) {
      return /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        children: /*#__PURE__*/_jsx(UIHelpIcon, {
          title: tooltip,
          tooltipPlacement: "right",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            "data-test-id": "email-type-can-not-change",
            message: `EmailData.emailTypes.${email.emailType}`
          })
        })
      });
    }
    return /*#__PURE__*/_jsx(_Fragment, {
      children: buttons
    });
  }, [buttons, canChangeEmailType, email, tooltip]);
  if (!shouldRenderEmailTypeSelectOption) {
    return null;
  }
  return /*#__PURE__*/_jsx(FormControl, {
    marginBlockStart: "400",
    "data-test-id": "email-type-selectable-buttons",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "email-type-select-modal-email-type-title",
      message: "EmailComponents.modals.creation.section.type"
    }),
    children: body
  });
}